(() => {
  const titleSelector = '.product-grid .product-item__name';

  const collapseTitle = (title) => {
    title.classList.remove('mobile-title-expanded');
    title.removeAttribute('aria-expanded');
  };

  document.addEventListener('click', (event) => {
    const selectedTitle = event.target.closest(titleSelector);

    document.querySelectorAll(`${titleSelector}.mobile-title-expanded`).forEach((title) => {
      if (title !== selectedTitle) collapseTitle(title);
    });

    if (!selectedTitle || selectedTitle.classList.contains('mobile-title-expanded')) return;

    const isTruncated = selectedTitle.scrollHeight > selectedTitle.clientHeight + 1;
    if (!isTruncated) return;

    event.preventDefault();
    selectedTitle.classList.add('mobile-title-expanded');
    selectedTitle.setAttribute('aria-expanded', 'true');
  });
})();
